var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { constructActions } from '../actions';
import { constructBlueprintReference } from '../blueprintReferences';
import { getIsBlueprintDerivedFlow, validateDerivedFlowSpecification, validateFlowSpecification, } from '../helpers';
import { constructTriggerCall } from '../triggers';
import { DefinitionType } from '../types';
export const constructFromFlowDefinition = (definition, blueprintRegistryClient, resourceRegistry, symbolTable, errors) => __awaiter(void 0, void 0, void 0, function* () {
    let isDerived = false;
    let spec = definition.flow.spec;
    let blueprintReference;
    if (getIsBlueprintDerivedFlow(spec)) {
        errors = errors.concat(validateDerivedFlowSpecification(spec));
        const [output, blueprintDefinedSpec] = yield constructBlueprintReference(resourceRegistry, spec, blueprintRegistryClient);
        blueprintReference = output;
        spec = blueprintDefinedSpec;
    }
    else {
        errors = errors.concat(validateFlowSpecification(spec));
    }
    const trigger = yield constructTriggerCall(spec.trigger, resourceRegistry, symbolTable);
    const actions = yield constructActions(spec.actions, resourceRegistry, symbolTable);
    return Object.assign(Object.assign({ type: DefinitionType.Flow, name: definition.flow.name, description: definition.flow.description }, (!!blueprintReference ? { blueprintReference } : {})), { trigger, tags: definition.flow.tags, actions: actions !== null && actions !== void 0 ? actions : [], isDerived,
        errors });
});
//# sourceMappingURL=flow.js.map